import * as Yup from "yup";

import {validationMessages} from "../../form/utils/validation_messages";

export const loginFormValidationSchema = Yup.object().shape({
    email: Yup.string().required(validationMessages.required).email(validationMessages.email),
    password: Yup.string().required(validationMessages.required)
});
import * as Yup from "yup";

import {validationMessages} from "../../form/utils/validation_messages";

export const loginFormValidationSchema = Yup.object().shape({
    email: Yup.string().required(validationMessages.required).email(validationMessages.email),
    password: Yup.string().required(validationMessages.required)
});
